import { render, staticRenderFns } from "./newsletter-signup.vue?vue&type=template&id=bed3dac4&scoped=true"
import script from "./newsletter-signup.vue?vue&type=script&lang=js"
export * from "./newsletter-signup.vue?vue&type=script&lang=js"
import style0 from "./newsletter-signup.vue?vue&type=style&index=0&id=bed3dac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed3dac4",
  null
  
)

export default component.exports